import {
  type CartDataFragment,
  type SubmitBagOrderWithPaymentMethodMutation,
} from '../../../../../graphql/operations.generated';
import { CartDocument } from '../../../../../hooks/useCart/GraphQL/Cart.generated';
import { LastOrderDateDocument } from '../../../../../hooks/usePostOrder';

import type { Cache } from '@urql/exchange-graphcache';

// ────────────────────────────────────────────────────────────────────────────────

export function updateCartCache(cache: Cache, responseWithCart: MutationResponseWithCart) {
  const cart = responseWithCart.cart;

  if (!cart) return;

  cache.updateQuery({ query: CartDocument }, (data) => {
    if (!data) return { __typename: 'Query', cart };

    data.cart = cart;

    return data;
  });
}

export function clearCartCacheEntry(cache: Cache) {
  cache.updateQuery({ query: CartDocument }, (data) => {
    if (data) data.cart = null;

    return data;
  });
}

export function invalidateCartCacheEntry(
  cache: Cache,
  response: SubmitBagOrderWithPaymentMethodMutation['submitOrderUsingPaymentMethod'],
) {
  const result = response?.__typename;
  const isSubmitted = result === 'SubmitOrderUsingPaymentMethodSuccess';

  if (isSubmitted) {
    clearCartCacheEntry(cache);
  }
}

export function updateOrderPostSubmission(
  cache: Cache,
  response: SubmitBagOrderWithPaymentMethodMutation['submitOrderUsingPaymentMethod'],
) {
  const result = response?.__typename;
  const isSubmitted = result === 'SubmitOrderUsingPaymentMethodSuccess';

  if (isSubmitted) {
    cache.updateQuery(
      {
        query: LastOrderDateDocument,
        variables: {
          input: {
            page: 1,
            take: 1,
          },
        },
      },
      (data) => {
        const lastOrderResponse = {
          __typename: 'OrdersResponseSuccess',
          orders: {
            __typename: 'OrdersResponseSuccess',
            orders: [response.order],
          },
        };

        data = lastOrderResponse;

        return data;
      },
    );
  }
}

// ─── TYPES ──────────────────────────────────────────────────────────────────────

export type MutationResponseWithCart = Readonly<{
  cart?: Partial<CartDataFragment>;
  __typename?: string;
}>;
